import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/delete-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "DELETE_PICKING_" }
);

export interface DeletePickingState extends IState {}

const INITIAL_STATE: DeletePickingState = {
  loading: false,
  error: null,
};

const request = (state: DeletePickingState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: DeletePickingState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: DeletePickingState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deletePicking = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const deletePickingTypes = Types;
export const deletePickingActions = Creators;
